import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { investorApi } from '../../services/adminApi';
import '../../styles/AdminPages.css';

const InvestorXpPage = () => {
  const navigate = useNavigate();
  const [investors, setInvestors] = useState([]);
  const [xpData, setXpData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        const investorResponse = await investorApi.getAll({ pageSize: 100 });
        const investorList = investorResponse?.data?.[0] || investorResponse?.data || [];
        setInvestors(Array.isArray(investorList) ? investorList : []);
        
        const xpResults = {};
        await Promise.all(
          investorList.map(async (investor) => {
            try {
              const response = await fetch(`https://api.tannit.uk/Ecovest/myxp/${investor.id}`);
              const result = await response.json();
              if (result?.status?.code === 1 && result?.data) {
                xpResults[investor.id] = result.data;
              }
            } catch (err) {
              console.log(`No XP data for investor ${investor.id}`);
            }
          })
        );
        setXpData(xpResults);
        setError(null);
      } catch (err) {
        console.error('Failed to fetch data:', err);
        setError('Failed to load investor XP data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const getInvestorXp = (investorId) => {
    const data = xpData[investorId];
    if (!data) return { xp: 0, level: 0 };
    if (Array.isArray(data) && data[0]) {
      return { xp: data[0].xp || data[0].totalXp || 0, level: data[0].level || 0 };
    }
    return { xp: data.xp || data.totalXp || 0, level: data.level || 0 };
  };

  const investorsWithXp = investors.filter(inv => {
    const xp = getInvestorXp(inv.id);
    return xp.xp > 0 || xp.level > 0;
  });

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <button 
            onClick={() => navigate(-1)} 
            style={{
              background: '#f1f5f9',
              border: 'none',
              borderRadius: '8px',
              padding: '10px 15px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              color: '#475569',
              fontWeight: '500',
              transition: 'all 0.2s ease'
            }}
            onMouseOver={(e) => e.currentTarget.style.background = '#e2e8f0'}
            onMouseOut={(e) => e.currentTarget.style.background = '#f1f5f9'}
          >
            <span style={{ fontSize: '16px' }}>←</span> Back
          </button>
          <div>
            <h1>Investor XP</h1>
            <p>View investor experience points (via Ecovest API)</p>
          </div>
        </div>
      </div>

      <div className="admin-table-card">
        {error && (
          <div className="admin-form-error" style={{ margin: '20px', borderRadius: '8px' }}>
            {error}
          </div>
        )}
        
        <table className="admin-table">
          <thead>
            <tr>
              <th>Investor ID</th>
              <th>Name</th>
              <th>XP Points</th>
              <th>Level</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr className="admin-loading-row">
                <td colSpan="4">
                  <div className="admin-table-loading">
                    <div className="admin-spinner"></div>
                    <span>Loading...</span>
                  </div>
                </td>
              </tr>
            ) : investorsWithXp.length === 0 ? (
              <tr>
                <td colSpan="4" className="admin-empty">
                  No investors with XP data found
                </td>
              </tr>
            ) : (
              investorsWithXp.map((investor) => {
                const xp = getInvestorXp(investor.id);
                return (
                  <tr key={investor.id}>
                    <td>{investor.id}</td>
                    <td>{`${investor.firstName || ''} ${investor.lastName || ''}`.trim() || '-'}</td>
                    <td>
                      <span className="badge bg-primary">{xp.xp.toLocaleString()} XP</span>
                    </td>
                    <td>
                      <span className="badge bg-success">Level {xp.level}</span>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InvestorXpPage;
